import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { useSelector } from 'react-redux';
import { useCurrentStep } from '../hooks/useCurrentStep';
import { useSignupData } from '../signup-data/useSignupData';
import { getGuessedDataBiden } from '../store/guessed-prefill/selectors';
import { TrackWhen, useExperiment } from '../experiments/useExperiment';
import { ExperimentKeys } from '../experiments/ExperimentKeys';
export const GuessedPrefillHelperText = ({
  dataKey
}) => {
  const {
    currentStep
  } = useCurrentStep();
  const {
    data
  } = useSignupData(dataKey);
  const guessedData = useSelector(getGuessedDataBiden(dataKey));
  const {
    isAssignedToVariant: isAssignedToVariantACQ0134
  } = useExperiment(ExperimentKeys.ACQ0134, TrackWhen.never);

  if (!guessedData || isAssignedToVariantACQ0134()) {
    return null;
  }

  const isGuessedDataInInput = guessedData === data;
  const labelKey = `views.${currentStep}.help`;

  if (isGuessedDataInInput && isValidI18nKey(labelKey)) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: labelKey
    });
  }

  return null;
};